<script lang="ts">
	import { TruncateType } from '.'
	import TextWithIcon from '../textWithIcon/TextWithIcon.svelte'
	import { Tooltip } from '@repo/ui'

	interface Props {
		value: string
		maxLength: number
		truncateType?: TruncateType
		noTooltip?: boolean
	}

	let { value, maxLength, truncateType = TruncateType.Start, noTooltip = false }: Props = $props()
</script>

<TextWithIcon>
	{#if value.length <= maxLength}
		{value}
	{:else}
		<span>
			{#if truncateType === TruncateType.End}
				{value.substring(0, maxLength)}&hellip;
			{:else if truncateType === TruncateType.Middle}
				{value.substring(0, maxLength / 2)}&hellip;{value.substring(
					value.length - (maxLength - maxLength / 2),
				)}
			{:else if truncateType === TruncateType.Start}
				&hellip;{value.substring(value.length - maxLength)}
			{/if}
		</span>
		{#if !noTooltip}
			<Tooltip>
				{value}
			</Tooltip>
		{/if}
	{/if}
</TextWithIcon>
